import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { CuentaTrabajo } from 'src/app/dashboard/interfaces/cuenta-trabajo.interface';

@Component({
  selector: 'app-working-account-list',
  templateUrl: './working-account-list.component.html',
  styleUrls: ['./working-account-list.component.sass']
})
export class WorkingAccountListComponent {
  usuarioID: number | undefined;
  @Output() reloadAccountList: EventEmitter<any> = new EventEmitter();
  @Output() actualizarCuenta: EventEmitter<CuentaTrabajo> = new EventEmitter();
  @Output() seleccion: EventEmitter<CuentaTrabajo> = new EventEmitter();
  subscriptions: Subscription = new Subscription();
  @Input() listaCuentas: CuentaTrabajo[] = [];

  @Input() seleccionable: boolean = false;
  cuentaSeleccionada: CuentaTrabajo | undefined;
  constructor(

  ) {
  }


  ngOnInit(): void {

  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  eliminarCuenta(){
    this.reloadAccountList.emit();
  }

  actualizar(cuenta: CuentaTrabajo){
    this.actualizarCuenta.emit(cuenta);
  }
}
